'use client';
// import EditText from '@/components/ui/EditText';
 import Button from'@/components/ui/Button';
import Link from 'next/link';
 


const CommunitySection = () => {
  return (
    <section className="w-full bg-[#ffadc640] py-8 lg:py-[44px]">
      <div className="w-full max-w-[1240px] mx-auto px-8 lg:px-[56px]">
        <div className="flex flex-col gap-6 lg:gap-[32px] justify-start items-center w-full">
          {/* Heading */}
          <div className="flex flex-col gap-4 lg:gap-[24px] justify-start items-center w-full px-4 lg:px-[28px]">
            <h2 className="text-[24px] sm:text-[30px] lg:text-4xl font-extrabold leading-[28px] sm:leading-[34px] lg:leading-5xl text-center text-text-darkest mt-2 lg:mt-[10px]">
              Community
            </h2>

            <h3 className="text-[20px] sm:text-[26px] lg:text-2xl font-normal leading-[24px] sm:leading-[30px] lg:leading-4xl text-center text-text-darkest mt-2 lg:mt-[12px]">
              Benefits of joining:
            </h3>

            {/* Centered List */}
            <ul className="flex flex-col sm:flex-row justify-center items-start w-full gap-4 sm:gap-12 list-disc pl-6 sm:pl-0 text-text-darkest">
              <li className="text-[16px] sm:text-[18px] lg:text-2xl font-helveticaThin font-normal leading-[26px] text-left sm:text-left  w-full sm:w-[32%]">
                Networking with women VCs and AI founders
              </li>
              <li className="text-[16px] sm:text-[18px] lg:text-2xl font-normal leading-[26px] text-left sm:text-center w-full sm:w-auto">
                Collaboration opportunities
              </li>
            </ul>
          </div>

          {/* Button */}
           <Link href='/contact'>
           <Button
              text="Host an event with us"
              text_font_size="text-base"
              text_font_family="Inter"
              text_font_weight="font-semibold"
              text_line_height="leading-xl"
              text_text_align="center"
              text_color="text-white"
              fill_background_color="bg-[#fa4b7f]"
              border_border_radius="rounded-sm"
              layout_align_self="center"
              padding="py-[14px] px-[22px] pr-[36px]"
              className="gap-[2px] py-[14px] px-[22px] pr-[36px] hover:bg-black transition-colors duration-200"
            >
            </Button>
             </Link>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
